import cn from 'classnames';
import React from 'react';

import s from './ErrorLabel.module.scss';

interface Props {
  children: string | JSX.Element;
  className?: string;
}
export default function ErrorLabel({
  children,
  className,
}: Props): JSX.Element {
  return <div className={cn(s.label, className)}>{children}</div>;
}
